function SesothoPage(){
    return <div>
        <div>
           About sesotho
        </div>
    </div>
}

export default SesothoPage;